import { makeStyles } from 'tss-react/mui';

const useStylesTableSortLabel: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  tableSortLabelFilter: {
    '&:focus': {
      color: `${theme.palette.common.white} !important`,
    },
    '&:active': {
      color: `${theme.palette.common.white} !important`,
    },
    '&:hover': {
      color: `${theme.palette.common.white} !important`,
      '& > svg:last-of-type': {
        color: `${theme.palette.secondary.main} !important`,
      },
    },
    '& > svg:last-of-type': {
      display: 'none',
    },
  },
  tableSortLabelFilterActive: {
    color: `${theme.palette.common.white} !important`,
    '& > svg:last-of-type': {
      display: 'inline-flex !important',
      width: 14,
      height: 14,
      marginTop: -2,
      color: `${theme.palette.secondary.main} !important`,
    },
  },
}));

export default useStylesTableSortLabel;
